var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"app-section",attrs:{"flat":"","tile":""}},[(_vm.$slots.title)?_c('v-card-title',{class:_vm.titleClasses},[_vm._t("title")],2):_vm._e(),_c('v-card-text',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }